import AbstractModule from './AbstractModule';
import { APP_NAME, $body, $document } from '../utils/environment';

const DATA_KEY  = `${APP_NAME}.Alert`;
const EVENT_KEY = `.${DATA_KEY}`;

const API = {
    DISMISS:        'api/alert/dismiss',
    DISMISS_SURVEY: 'api/survey/dismiss'

};

const Event = {
    CLICK:  `click${EVENT_KEY}`
};

const ClassName = {
    HAS_ALERT:  'has-alert'
};

const Selector = {
    ALERT:    '[data-alert-id]',
    DISMISS:  '[data-dismiss="alert"]',
    DISMISS_SURVEY:  '[data-dismiss="survey"]'
};

/**
 * Latest News Alerts
 */
export default class extends AbstractModule
{
    constructor (options)
    {
        super(options);

        let alerts = JSON.parse(window.localStorage.getItem('alerts'));
        const alertId = $(this.$el).attr('data-alert-id');
        if(alertId && alerts && (alerts.indexOf(alertId) !== -1)) {
            this.$el.remove()
        }

        this.$el
            .on(Event.CLICK, Selector.DISMISS, (event) => {
                event.preventDefault();

                var $trigger, $target, callback;

                $trigger = $(event.currentTarget);
                $target  = $trigger.closest(Selector.ALERT);

                if (event.currentTarget.href) {
                    callback = () => {
                        window.location.href = event.currentTarget.href
                    };
                } else {
                    callback = () => {
                        this.closeAlert($target);
                    };
                }

                this.dismissAlert($target, callback);
            });

        if (this.$el.find(Selector.ALERT).length > 0) {
            $body.addClass(ClassName.HAS_ALERT);
        }

        $document.on('click', Selector.DISMISS_SURVEY, (event) => {
            // Close current survey
            $.post(API.DISMISS_SURVEY, () => {}, 'json');
            this.closeSurvey($(event.currentTarget).parents(Selector.ALERT));
        });
    }

    closeSurvey($target)
    {
        if ($target && $target.length) {
            $target.slideUp(300, () => {
                $target.remove();

                if (this.$el.find(Selector.ALERT).length === 0) {
                    $body.removeClass(ClassName.HAS_ALERT);
                }
            });
        }
    }


    dismissAlert($target, callback)
    {
        let alertId = $target.data('alert-id');

        let alerts = JSON.parse(window.localStorage.getItem('alerts'));
        if(!alerts) alerts = [];
        alerts.push(alertId);
        window.localStorage.setItem('alerts', JSON.stringify(alerts));

        if (alertId) {
            let xhr = $.post(API.DISMISS, { alert: alertId });

            if ($.isFunction(callback)) {
                xhr.always(callback);
            }
        }
        
    }

    closeAlert($target)
    {
        if ($target && $target.length) {
            $target.slideUp(300, () => {
                $target.remove();

                if (this.$el.find(Selector.ALERT).length === 0) {
                    $body.removeClass(ClassName.HAS_ALERT);
                }
            });
        }
    }

    destroy()
    {
        $body.removeClass(ClassName.HAS_ALERT);

        this.$el.off(EVENT_KEY);
        this.$el.remove();
    }
}
